// extracted by mini-css-extract-plugin
export default {"cardRadio":"index_cardRadio__kMVTY","proposalCard":"index_proposalCard__BL+wi","leadDetailForm":"index_leadDetailForm__kPABB"};